import type { RoundingSavingsConfig } from '@shared/products-feature-configs';

export const roundingSavings: RoundingSavingsConfig = {
    enabled: false,
    showSFondsPlan: false,
    turboSavingOptions: [],
    simulationMonthOptions: [],
    savingGoals: [],
    sFondsGoals: [],
};
